<template>
    <div>
        <div class="text-small text-gray pb-8">
            <a href="/admin">Admin</a> > <a href="/admin/users">Users</a> > {{ userFullName }}
        </div>
        <header class="flex justify-between">
            <h2 class=" text-primary-500">
                Manage User Data: {{ userFullName }}
            </h2>
        </header>
        <d-tabs v-model="activeTab">
            <d-tab-item label="Basic Info">
                <user-profile-basic-info :user-id="userId" :can-edit-user="canEditUser" />
            </d-tab-item>
            <d-tab-item v-if="isMentor" label="Mentor Data">
                <user-profile-mentor-data-tab :user-id="userId" />
            </d-tab-item>
            <d-tab-item v-if="isMentee" label="Mentee Data">
                <user-profile-mentee-data-tab :user-id="userId" />
            </d-tab-item>
            <d-tab-item label="Groups">
                <user-profile-groups-tab :user-id="userId" />
            </d-tab-item>
            <d-tab-item label="Addresses">
                <user-profile-addresses-tab :user-id="userId" />
            </d-tab-item>
            <d-tab-item label="Schools">
                <user-profile-schools-tab :user-id="userId" />
            </d-tab-item>
            <d-tab-item label="Communities">
                <user-profile-communities-tab :user-id="userId" />
            </d-tab-item>
            <d-tab-item label="Programs/Pathways/Emphases">
                <user-profile-program-pathway-emphasis-tab :user-id="userId" />
            </d-tab-item>
        </d-tabs>
    </div>
</template>
<script>

    export default {
        parent: true,
        props: {
            userFullName: {
                type: String,
                default: () => '',
            },
            userId: {
                type: String,
                default: () => '',
            },
            canEditUser: {
                type: Boolean,
                default: () => false,
            },
            isMentor: {
                type: Boolean,
                default: () => false,
            },
            isMentee: {
                type: Boolean,
                default: () => false,
            },
        },
        data: () => ({
            activeTab: 0,

        }),

    };
</script>